<app-wizard-modal [concludesInDelete]="true"
                  (stepChange)="onStepChange($event)"
                  (cancel)="onCancel()"
                  (submit)="onSubmit()">

    <app-wizard-title *ngIf="selectedTool">
        {{'admin.tools.details.detailsPage.modals.delete-confirmation-modal.title' | translate:{toolName:
        selectedTool?.name}
        }}
    </app-wizard-title>

    <app-wizard-title *ngIf="!selectedTool">{{'admin.tools.deleteConfirmationModal.modalTitle' | translate}}</app-wizard-title>
    <app-wizard-step [canContinue]="selectToolsForm.valid">
        <ng-template #title>{{'admin.tools.details.detailsPage.modals.delete-confirmation-modal.step1' | translate}}
        </ng-template>
        <ng-template #content
                     let-step="step">
            <form [formGroup]="selectToolsForm">
                <div class="col s12" style="padding-left: 0;padding-top:15px;">
                    <app-tool-inspect-tree
                        [isScanListenerActive]="isScanListenerActive"
                        [isMaterial]="false"
                        [formControl]="selectToolsForm.controls['selectedTools']"
                        [showErrors]="step.nextTriggered"
                        [items]="scannedTools"
                        (itemNotFound)="onItemNotFound($event)">
                    </app-tool-inspect-tree>
                </div>
            </form>

        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]="selectToolsForm.valid">
        <ng-template #title>{{'admin.tools.details.detailsPage.modals.delete-confirmation-modal.step2' | translate}}
        </ng-template>
        <ng-template #content
                     let-step="step">
            <form [formGroup]="reasonForm">
                <div class="col s12" style="padding-left: 0;padding-top:15px;padding-bottom: 30px">
                    <app-textarea [formControl]="reasonForm.controls['deleteReason']"
                                  [showErrors]="showValidations"
                                  [maxLength]="120"
                                  [placeholder]="'admin.tools.details.detailsPage.modals.delete-confirmation-modal.step2' | translate">
                    </app-textarea>
                </div>
            </form>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
